import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'
import Loading from '../../../components/Loading'
import BankChangeCustomerDetails from './BankChangeCustomerDetails'

const BankChangeDecisionForm = ({
  customerData,
  oldAccountLastFour,
  oldAccountRouting,
  showDecisionControls,
  bankChangeStatus,
  setBankChangeStatus,
  bankChangeReason,
  setBankChangeReason,
  isSubmitting,
  canSubmit,
  onSubmit,
}) => (
  <div className="box mb-3 ml-2 mr-2 lox-max-width-720">
    <div className="columns mb-0">
      <div className="column is-12">
        <h4 className="title is-6 mb-2">
          <FontAwesomeIcon icon={faCreditCard} className="mr-2" />
          Bank Change Information
        </h4>
        <BankChangeCustomerDetails
          customerData={customerData}
          oldAccountLastFour={oldAccountLastFour}
          oldAccountRouting={oldAccountRouting}
          variant="stacked"
        />
        {showDecisionControls && (
          <>
            <fieldset className="field mb-2 lox-max-width-420">
              <legend className="label is-small mb-1">Status</legend>
              <div className="control is-flex is-align-items-center">
                <label className="radio mr-3">
                  <input
                    type="radio"
                    name="bankChangeStatus"
                    value="approved"
                    checked={bankChangeStatus === 'approved'}
                    onChange={(e) => setBankChangeStatus(e.target.value)}
                  />
                  <span className="ml-1">Approve</span>
                </label>
                <label className="radio">
                  <input
                    type="radio"
                    name="bankChangeStatus"
                    value="denied"
                    checked={bankChangeStatus === 'denied'}
                    onChange={(e) => setBankChangeStatus(e.target.value)}
                  />
                  <span className="ml-1">Deny</span>
                </label>
              </div>
            </fieldset>
            <div className="field mb-3 lox-max-width-720">
              <label className="label is-small mb-1" htmlFor="chirp-bank-change-reason">Reason</label>
              <div className="control">
                <textarea
                  id="chirp-bank-change-reason"
                  className="textarea is-small"
                  placeholder="Add reason..."
                  value={bankChangeReason}
                  onChange={(e) => setBankChangeReason(e.target.value)}
                  rows={3}
                />
              </div>
            </div>
            <div className="field">
              <div className="control">
                <button
                  className="button is-primary is-small"
                  type="button"
                  disabled={isSubmitting || bankChangeStatus === 'pending' || !canSubmit}
                  onClick={onSubmit}
                >
                  {isSubmitting ? (
                    <>
                      <Loading size="is-size-7" noWrapper />
                      <span className="ml-2">Submitting</span>
                    </>
                  ) : (
                    'Submit Bank Change'
                  )}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
)

export default BankChangeDecisionForm
